import { auth } from "auth"
import { Button, Modal } from "materia"
import { sendVuplexMessage } from "../../vuplex/sendVuplexMessage"
import s from "./ConnectionIssueModal.module.scss"

// This component is special because it might be rendered before anything else
// is initialized. Therefore it doesn't have access to many things like
// Lokalise or backoffice api.

export const ConnectionIssueModal = () => {
  const handleNukeActiveSession = () => {
    sendVuplexMessage({ type: "LOGOUT" })
    auth.logoutAndLogin()

    // TODO: Normal app's logout button also handles SLO with redirect.
    // At this stage we don't have info about company having SLO enabled,
    // so we don't handle this, but it may be worth revisiting
    //
    // if (isSingleLogOutEnabled) auth.logoutAndSLORedirect()
  }

  const handleRefreshPage = () => {
    window.location.reload()
  }

  return (
    <Modal onClose={() => {}} ariaLabel="Something went wrong">
      <div className={s.connectionIssueModal}>
        <div className={s.connectionIssueModal__title}>Can't connect</div>
        <div className={s.connectionIssueModal__description}>
          We're having trouble reaching our servers. This might be a temporary
          network issue.
        </div>

        <Button theme="blue" onClick={handleNukeActiveSession}>
          Sign in again
        </Button>

        <Button theme="cancel" onClick={handleRefreshPage}>
          Refresh page
        </Button>
      </div>
    </Modal>
  )
}
